import styled from 'styled-components';
import { IconCheck } from '../Icons/IconCheck.js';
import { IconDash } from '../Icons/IconDash.js';
import { IconLock } from '../Icons/IconLock.js';
import { jsx } from 'react/jsx-runtime';

var checkBoxIconSize = {
  16: 12,
  20: 14,
  24: 16,
  32: 24
};
var CheckboxIconBase = styled.div.withConfig({
  displayName: "CheckboxIcons__CheckboxIconBase",
  componentId: "sc-nr5qlv-0"
})(["&&{display:flex;align-items:center;justify-content:center;border-radius:", "px;height:", "px;width:", "px;}"], function (props) {
  return props.size > 19 ? 4 : 3;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var CheckboxIconUnchecked = styled(CheckboxIconBase).withConfig({
  displayName: "CheckboxIcons__CheckboxIconUnchecked",
  componentId: "sc-nr5qlv-1"
})(["&&{border:2px solid ", ";}"], function (_ref) {
  var disabled = _ref.disabled,
    theme = _ref.theme;
  return disabled ? theme.neutralColors.silver : theme.neutralColors.smoke;
});
var CheckboxIconChecked = styled(CheckboxIconBase).attrs(function (props) {
  return {
    children: /*#__PURE__*/jsx(IconCheck, {
      color: props.theme.neutralColors.white,
      height: checkBoxIconSize[props.size],
      width: checkBoxIconSize[props.size]
    })
  };
}).withConfig({
  displayName: "CheckboxIcons__CheckboxIconChecked",
  componentId: "sc-nr5qlv-2"
})(["&&{border-color:", ";background-color:", ";", ";}"], function (props) {
  return props.theme.CTAColors.primary;
}, function (props) {
  return props.theme.CTAColors.primary;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "opacity: 0.5" : void 0;
});
var CheckboxIconLocked = styled(CheckboxIconBase).attrs(function (_ref3) {
  var size = _ref3.size,
    theme = _ref3.theme;
  return {
    children: /*#__PURE__*/jsx(IconLock, {
      color: theme.neutralColors.white,
      height: checkBoxIconSize[size],
      width: checkBoxIconSize[size]
    })
  };
}).withConfig({
  displayName: "CheckboxIcons__CheckboxIconLocked",
  componentId: "sc-nr5qlv-3"
})(["&&{border-color:", ";background-color:", ";", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.CTAColors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.CTAColors.primary;
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? "opacity: 0.5" : void 0;
});
var StyledIconDash = styled(IconDash).withConfig({
  displayName: "CheckboxIcons__StyledIconDash",
  componentId: "sc-nr5qlv-4"
})(["&&{width:", "px;}&& path{stroke-width:4px;}"], function (props) {
  return props.size / 1.75;
});
var CheckboxIconIndeterminate = styled(CheckboxIconBase).attrs(function (_ref7) {
  var disabled = _ref7.disabled,
    size = _ref7.size,
    theme = _ref7.theme;
  return {
    children: /*#__PURE__*/jsx(StyledIconDash, {
      color: disabled ? theme.neutralColors.silver : theme.CTAColors.primary,
      height: checkBoxIconSize[size],
      width: checkBoxIconSize[size],
      size: size
    })
  };
}).withConfig({
  displayName: "CheckboxIcons__CheckboxIconIndeterminate",
  componentId: "sc-nr5qlv-5"
})(["&&{border-width:2px;border-style:solid;border-color:", ";background-color:", ";}"], function (_ref8) {
  var disabled = _ref8.disabled,
    theme = _ref8.theme;
  return disabled ? theme.neutralColors.silver : theme.CTAColors.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.neutralColors.white;
});
var CheckboxIconCustom = styled.div.withConfig({
  displayName: "CheckboxIcons__CheckboxIconCustom",
  componentId: "sc-nr5qlv-6"
})(["&&{", ";}"], function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled ? "opacity: 0.5" : void 0;
});

export { CheckboxIconChecked, CheckboxIconCustom, CheckboxIconIndeterminate, CheckboxIconLocked, CheckboxIconUnchecked };
